module.exports = __webpack_public_path__ + "static/media/rsmclock.c48e14e9.svg";